var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentralizedKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 8,
    y1: 8,
    x2: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FE0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB58F"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 8,
    fill: "url(#g1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 12,
    r: 4,
    fill: "url(#g1)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 29,
    r: 4,
    fill: "url(#g1)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 46,
    r: 4,
    fill: "url(#g1)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 29,
    r: 4,
    fill: "url(#g1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16V21",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29H42",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37V42",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29H21",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26C25 24.9 25.9 24 27 24H31C32.1 24 33 24.9 33 26V34H27C25.9 34 25 33.1 25 32V26Z",
    fill: "white",
    opacity: 0.95
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26C33 24.9 32.1 24 31 24H27C25.9 24 25 24.9 25 26",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralizedKnowledge);
export default __webpack_public_path__ + "static/media/Centralized_Knowledge.960cf94272f2462eeb4f2acd39711e3b.svg";
export { ForwardRef as ReactComponent };